import React from 'react';
import { Table as SemanticTable } from 'semantic-ui-react';
import { PhoneUtil } from 'utils';

const SessionSubTable = ({ users }) => (
    <SemanticTable compact className='CampaignSessionSummary__subTable'>
        <SemanticTable.Header>
            <SemanticTable.Row>
                <SemanticTable.HeaderCell>User</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Campaign Number</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Total Contacts</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Sent</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Pending</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Failed</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Opt-Out</SemanticTable.HeaderCell>
            </SemanticTable.Row>
        </SemanticTable.Header>
        <SemanticTable.Body>
            {users?.map((user, idx) => (
                <SemanticTable.Row key={idx}>
                    <SemanticTable.Cell>{user.name}</SemanticTable.Cell>
                    <SemanticTable.Cell>{PhoneUtil.formatPhoneNumber(user.phone)}</SemanticTable.Cell>
                    <SemanticTable.Cell>{user.total ?? 0}</SemanticTable.Cell>
                    <SemanticTable.Cell>{user.sent ?? 0}</SemanticTable.Cell>
                    <SemanticTable.Cell>{user.pending ?? 0}</SemanticTable.Cell>
                    <SemanticTable.Cell>{user.failed ?? 0}</SemanticTable.Cell>
                    <SemanticTable.Cell>{user.optout ?? 0}</SemanticTable.Cell>
                </SemanticTable.Row>
            ))}
        </SemanticTable.Body>
    </SemanticTable>
);

export default SessionSubTable;
